import { cn } from '../../utils/class-merge';
import SvgSearch from '../icons/Search';
import { Input } from '../input/input';

interface DataTableSearchProps {
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  value: string;
}

export const DataTableSearch = ({
  placeholder,
  className,
  onChange,
  value,
}: DataTableSearchProps) => {
  return (
    <Input
      trailingIcon={{
        position: 'left',
        icon: <SvgSearch className="text-weak" />,
      }}
      className={cn('rounded-md w-64', className)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      inputSize="small"
      value={value}
      name="test"
    />
  );
};
